function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.792 2.561a4.1 4.1 0 00-5.807 0l-1.33 1.332a.676.676 0 01-.959 0l-1.33-1.332a4.109 4.109 0 00-5.807 5.814l.019.019 7.6 8.244 7.6-8.244.019-.019a4.114 4.114 0 000-5.814m-6.77-.961a5.465 5.465 0 017.736 7.722L10.674 18.1a.678.678 0 01-1 0L1.59 9.324A5.466 5.466 0 019.325 1.6l.851.851z",
  fillRule: "evenodd"
});

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.351 18.317",
    className: "w-full h-full fill-current"
  }, props), _ref);
}

export default SvgHeart;